import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { EmailTemplate } from '../../models/EmailTemplate/EmailTemplate-model';
import { Observable } from 'rxjs/Observable';
import { Router } from "@angular/router";
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class EmailTemplateService {
  constructor(private http: Http, private readonly router: Router, private cookieService: CookieService) { }
  private serviceName = 'api/EmailTemplate';


  getEmailTemplate() {
    return this.http.get(`${this.serviceName}`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  addEmailTemplate(EmailTemplateModel: EmailTemplate) {
    

    return this.http.post(`${this.serviceName}/CreateEmailTemplate`, EmailTemplateModel, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }


  getEmailTemplateTriggerTo() {


    return this.http.get(`${this.serviceName}/GetEnumValues`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  

  updateEmailTemplate(EmailTemplateModel: EmailTemplate) {
    return this.http.post(`${this.serviceName}/UpdateEmailTemplate`, EmailTemplateModel, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  deleteEmailTemplate(id: string) {
    return this.http.get(`${this.serviceName}/DeleteEmailTemplate?id=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .subscribe(result => {
      });
      //.map((response: Response) => response.json())
      //.catch(this.errorHandler);
  }

  getEmailTemplateById(EmailTemplateId: string) {
    return this.http.get(`${this.serviceName}/GetEmailTemplateById?id=` + EmailTemplateId, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }


  getTemplateVariables() {
    return this.http.get(`${this.serviceName}/GetTemplateVariables`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  getTemplateVariablesByClass(ClassName: string) {
    return this.http.get(`${this.serviceName}/GetTemplateVariablesByClass?name=` + ClassName, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })

      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  errorHandler(error: Response) {
    
    return Observable.throw(error);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/EmailTemplate/EmailTemplate.service.ts